//Splash.tsx =================================================
import "./Util/Prototypes";

import * as MainMenu from "./Menus/MainMenu";
import * as Settings from "./Settings";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import React from "react";

let visible: boolean = true;

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
   }, []);

   function handleAgree() {
      //console.error("Handle Agree");
      visible = false;
      refresh();
      setTimeout(function () { MainMenu.render(); }, 600); //Focus name search box.
   }

   function handleDisagree() {
      window.history.back();
   }

   function handleClose(event, reason) {
   //   console.error("Handle Close: reason: " + reason);
   //   if (reason === "backdropClick") {
      return;
   //   }
   }

   //Render components. Custom! <DialogContentText id="alert-dialog-description" style={{ color: 'red' }}>
   return (
      <Dialog
         disableEscapeKeyDown
         open={visible}
         onClose={handleClose}
         aria-labelledby="alert-dialog-title"
         aria-describedby="alert-dialog-description"
      >
         <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 0, paddingTop: 9 }} ><i>Disclaimer:</i></DialogTitle>
         <DialogContent>
            <DialogContentText id="alert-dialog-description">
               Welcome to <b>Reassessment</b>
               <br /><br />
               This data is for informational purposes only and should not be substituted for a true title search,
               property appraisal, survey, or for zoning verification.
               <br /><br />
               CustomerName assumes no legal responsibility for the accuracy of the data on this website.
            </DialogContentText>

            <div className="app-flex-row-center" style={{ marginTop: 3 }}>
               <img style={{ height: 100 }} src={Settings.webSiteLogo} alt="logo" />
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={handleDisagree} color="info">
               Disagree
            </Button>
            <Button onClick={handleAgree} color="info" autoFocus>
               Agree
            </Button>
         </DialogActions>
      </Dialog>
   ); //end return.

} //end function.
